import {useCallback} from 'react'
import {CurrencyEnumIndices} from '@bdswiss/common-enums'
import {backendGetRequest} from '../../../../../../common/utils/requests'
import {getStartAndEndOfMonth} from '../utils'
import {useQuery, UseQueryResult} from './useQuery'

type Data = {
  statistics: {
    totalFollowers: number
    activeFollowers: number
    losingTrades: number
    winningTrades: number
    totalProfit: number
    totalPerformanceFee: number
    currency: CurrencyEnumIndices | null
  }
}

export function useStatistics(accountId: number, selectedDate?: string): UseQueryResult<Data> {
  const query = useCallback(async (): Promise<Data> => {
    const totalPeriod = {
      startsAt: new Date(0).toISOString(),
      endsAt: new Date().toISOString()
    }

    const params = selectedDate != null ? getStartAndEndOfMonth(selectedDate) : totalPeriod
    const response = await backendGetRequest(`/api/v2/dashboard/accounts/${accountId}/providers/brokeree/statistics`, true, params)

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`Failed to fetch provider statistics ${response.status} ${errorText}`)
    }

    return await response.json()
  }, [accountId, selectedDate])

  return useQuery(query)
}
